import Home from '@/views/Home'
import TourControl from '@/views/TourControl'
import MeetingRoomSchedules from '@/views/MeetingRoomSchedules'
import Login from '@/views/Login'
import MainSystemList from '@/views/system/MainSystemList'
import SubSystemList from '@/views/system/SubSystemList'
import EmployeeList from '@/views/system/EmployeeList'
import PermissionGroups from '@/views/system/PermissionGroups'
import CountryTemplates from '@/views/mis/CountryTemplates'
import CityTemplates from '@/views/mis/CityTemplates'
import AreaList from '@/views/basic/Areas'
import TravelAreaList from '@/views/basic/TravelAreas'
import AreaHomePage from '@/views/areas/AreaHomePage'
import Countries from '@/views/basic/Countries'
import Regions from '@/views/basic/Regions'
import Cities from '@/views/basic/Cities'
import Hotels from '@/views/basic/Hotels'
import Leaders from '@/views/basic/Leaders'
import CatalogList from '@/views/areas/Catalogs'
import CatalogBanners from '@/views/areas/CatalogBanners'
import CatalogTouristInfos from '@/views/areas/CatalogTouristInfos'
import CatalogTravelInfos from '@/views/areas/CatalogTravelInfos'
import Airlines from '@/views/basic/Airlines'
import FlySchedules from '@/views/basic/FlySchedules'
import HomeBanners from '@/views/home/Banners'
import HomeShareVideos from '@/views/home/ShareVideos'
import HomeHeader from '@/views/home/Header'
import HomeFooter from '@/views/home/Footer'
import TopTravels from '@/views/home/TopTravels'
import RecentlyHot from '@/views/home/RecentlyHot'
import FirmList from '@/views/firm/FirmList'
import ActivityList from '@/views/firm/ActivityList'
import CollaborateGroupList from '@/views/firm/TravelGroupList'
import CollaborateReports from '@/views/firm/Reports'
import FirmOrderList from '@/views/firm/FirmOrderList'
import ProductList from '@/views/products/List'
import ProductAdvanceList from '@/views/products/AdvanceList'
import ProductBatchList from '@/views/products/BatchList'
import ProductDeleteList from '@/views/products/DeleteList'
import ProductExport from '@/views/products/Export'
import TravelGroupList from '@/views/travel_groups/List'
import TravelGroupAdvanceList from '@/views/travel_groups/AdvanceList'
import TravelGroupBatchList from '@/views/travel_groups/BatchList'
import TravelGroupDeleteList from '@/views/travel_groups/DeleteList'
import CowellGroupList from '@/views/travel_groups/CowellGroupList'
import Orders from '@/views/order_management/Orders'
import Inquiries from '@/views/order_management/Inquiries'
import LectureOrders from '@/views/order_management/Lectures'
import BlogShares from '@/views/company/BlogShares'
import Satisfactions from '@/views/company/Satisfactions'
import TourismNews from '@/views/company/TourismNews'
import News from '@/views/company/News'
import Blog from '@/views/company/Blog'
import Offers from '@/views/company/Offers'
import BankOffers from '@/views/company/BankOffers'
import Edm from '@/views/company/Edm'
import Subscriptions from '@/views/company/Subscriptions'
import TourLeaders from '@/views/company/TourLeaders'
import Magazines from '@/views/company/Magazines'
import Meetings from '@/views/company/Meetings'
import GiftManagement from '@/views/gifts/Management'
import GiftPurchases from '@/views/gifts/Purchases'
import GiftTransfers from '@/views/gifts/Transfers'
import GiftApplications from '@/views/gifts/Applications'
import GiftReviews from '@/views/gifts/Reviews'
import AuthLogs from '@/views/logs/Auth'
import GroupPrice from '@/views/logs/GroupPrice'
import GroupStatus from '@/views/logs/GroupStatus'
import ProductPrice from '@/views/logs/ProductPrice'
import ProductStatus from '@/views/logs/ProductStatus'
import PagesSeo from '@/views/basic/PagesSeo'
import Weathers from '@/views/basic/Weathers'
import HoneyMoons from '@/views/company/HoneyMoons'
import TravelerTypes from '@/views/mis/TravelerTypes'
import UserList from '@/views/users/List'
import AreaRegions from '@/views/areas/AreaRegions'
import Attributes from '@/views/mis/Attributes'
import Companies from '@/views/mis/Companies'
import Demands from '@/views/order_management/Demands'
import Complaints from '@/views/order_management/Complaints.vue'
import PublicationDemands from '@/views/order_management/PublicationDemands'
import LineAuth from '@/views/LineAuth'
import Seminars from '@/views/company/Seminars'
import CruiseInquiries from '@/views/order_management/CruiseInquiries'
import ContractCase from '@/views/contract/ContractCase'
import ContractTemplates from '@/views/contract/ContractTemplates'
import TravelGroupReportRecords from '@/views/order_management/TravelGroupReportRecords'
import Banks from '@/views/basic/Banks'
import BusinessEntities from '@/views/basic/BusinessEntities'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/tour-control',
    name: 'tourControl',
    component: TourControl,
    meta: {
      auth: true
    }
  },
  {
    path: '/meeting-room-schedules',
    name: 'meetingRoomSchedules',
    component: MeetingRoomSchedules,
    meta: {
      auth: true
    }
  },
  {
    path: '/system/main-systems',
    name: 'mainSystemList',
    component: MainSystemList,
    meta: {
      auth: true
    }
  },
  {
    path: '/system/sub-systems',
    name: 'SubSystemList',
    component: SubSystemList,
    meta: {
      auth: true
    }
  },
  {
    path: '/system/employee-systems',
    name: 'EmployeeList',
    component: EmployeeList,
    meta: {
      auth: true
    }
  },
  {
    path: '/system/permission-groups',
    name: 'PermissionGroups',
    component: PermissionGroups,
    meta: {
      auth: true
    }
  },
  {
    path: '/mis/country-templates',
    name: 'CountryTemplates',
    component: CountryTemplates,
    meta: {
      auth: true
    }
  },
  {
    path: '/mis/city-templates',
    name: 'CityTemplates',
    component: CityTemplates,
    meta: {
      auth: true
    }
  },
  {
    path: '/mis/traveler-types',
    name: 'TravelerTypes',
    component: TravelerTypes,
    meta: {
      auth: true
    }
  },
  {
    path: '/mis/companies',
    name: 'Companies',
    component: Companies,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/areas',
    name: 'BasicAreas',
    component: AreaList,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/travel-areas',
    name: 'TravelAreas',
    component: TravelAreaList,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/countries',
    name: 'Countries',
    component: Countries,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/regions',
    name: 'Regions',
    component: Regions,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/cities',
    name: 'Cities',
    component: Cities,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/hotels',
    name: 'Hotels',
    component: Hotels,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/leaders',
    name: 'Leaders',
    component: Leaders,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/air-lines',
    name: 'Airlines',
    component: Airlines,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/flight-schedules',
    name: 'FlySchedules',
    component: FlySchedules,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/pages-seo',
    name: 'PagesSeo',
    component: PagesSeo,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/weathers',
    name: 'Weathers',
    component: Weathers,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/banks',
    name: 'Banks',
    component: Banks,
    meta: {
      auth: true
    }
  },
  {
    path: '/basic/business-entities',
    name: 'BusinessEntities',
    component: BusinessEntities,
    meta: {
      auth: true
    }
  },
  {
    path: '/area',
    name: 'AreaList',
    component: AreaList,
    meta: {
      auth: true
    }
  },
  {
    path: '/area/banners',
    name: 'AreaHomePage',
    component: AreaHomePage,
    meta: {
      auth: true
    }
  },
  {
    path: '/area/area-regions',
    name: 'AreaRegions',
    component: AreaRegions,
    meta: {
      auth: true
    }
  },
  {
    path: '/area/catalogs',
    name: 'CatalogList',
    component: CatalogList,
    meta: {
      auth: true
    }
  },
  {
    path: '/area/catalog-banners',
    name: 'CatalogBanners',
    component: CatalogBanners,
    meta: {
      auth: true
    }
  },
  {
    path: '/area/catalog-tourist-infos',
    name: 'CatalogTouristInfos',
    component: CatalogTouristInfos,
    meta: {
      auth: true
    }
  },
  {
    path: '/area/catalog-travel-infos',
    name: 'CatalogTravelInfos',
    component: CatalogTravelInfos,
    meta: {
      auth: true
    }
  },
  {
    path: '/home/banners',
    name: 'HomeBanners',
    component: HomeBanners,
    meta: {
      auth: true
    }
  },
  {
    path: '/home/share-videos',
    name: 'HomeShareVideos',
    component: HomeShareVideos,
    meta: {
      auth: true
    }
  },
  {
    path: '/home/header',
    name: 'HomeHeader',
    component: HomeHeader,
    meta: {
      auth: true
    }
  },
  {
    path: '/home/footer',
    name: 'HomeFooter',
    component: HomeFooter,
    meta: {
      auth: true
    }
  },
  {
    path: '/home/top-travels',
    name: 'TopTravels',
    component: TopTravels,
    meta: {
      auth: true
    }
  },
  {
    path: '/home/recently-hot',
    name: 'RecentlyHot',
    component: RecentlyHot,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/blog-shares',
    name: 'BlogShares',
    component: BlogShares,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/satisfactions',
    name: 'Satisfactions',
    component: Satisfactions,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/seminars',
    name: 'Seminars',
    component: Seminars,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/blog-shares',
    name: 'BlogShares',
    component: BlogShares,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/tourism-news',
    name: 'TourismNews',
    component: TourismNews,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/news',
    name: 'News',
    component: News,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/blog',
    name: 'Blog',
    component: Blog,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/offers',
    name: 'Offers',
    component: Offers,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/bank-offers',
    name: 'BankOffers',
    component: BankOffers,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/edm',
    name: 'Edm',
    component: Edm,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/honey-moons',
    name: 'HoneyMoons',
    component: HoneyMoons,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/subscriptions',
    name: 'Subscriptions',
    component: Subscriptions,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/tour-leaders',
    name: 'TourLeaders',
    component: TourLeaders,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/magazine',
    name: 'Magazine',
    component: Magazines,
    meta: {
      auth: true
    }
  },
  {
    path: '/company/meeting',
    name: 'Meetings',
    component: Meetings,
    meta: {
      auth: true
    }
  },
  {
    path: '/gifts/management',
    name: 'GiftManagement',
    component: GiftManagement,
    meta: {
      auth: true
    }
  },
  {
    path: '/gifts/purchases',
    name: 'GiftPurchases',
    component: GiftPurchases,
    meta: {
      auth: true
    }
  },
  {
    path: '/gifts/transfers',
    name: 'GiftTransfers',
    component: GiftTransfers,
    meta: {
      auth: true
    }
  },
  {
    path: '/gifts/applications',
    name: 'GiftApplications',
    component: GiftApplications,
    meta: {
      auth: true
    }
  },
  {
    path: '/gifts/reviews',
    name: 'GiftReviews',
    component: GiftReviews,
    meta: {
      auth: true
    }
  },
  {
    path: '/contract/contract-case',
    name: 'ContractCase',
    component: ContractCase,
    meta: {
      auth: true
    }
  },
  {
    path: '/contract/contract-templates',
    name: 'ContractTemplates',
    component: ContractTemplates,
    meta: {
      auth: true
    }
  },
  {
    path: '/firm',
    name: 'FirmList',
    component: FirmList,
    meta: {
      auth: true
    }
  },
  {
    path: '/firm/activities',
    name: 'ActivityList',
    component: ActivityList,
    meta: {
      auth: true
    }
  },
  {
    path: '/firm/groups',
    name: 'CollaborateGroupList',
    component: CollaborateGroupList,
    meta: {
      auth: true
    }
  },
  {
    path: '/firm/reports',
    name: 'CollaborateReports',
    component: CollaborateReports,
    meta: {
      auth: true
    }
  },
  {
    path: '/firm/firm-orders',
    name: 'FirmOrder',
    component: FirmOrderList,
    meta: {
      auth: true
    }
  },
  {
    path: '/products',
    name: 'ProductList',
    component: ProductList,
    meta: {
      auth: true
    }
  },
  {
    path: '/products/advance',
    name: 'ProductAdvanceList',
    component: ProductAdvanceList,
    meta: {
      auth: true
    }
  },
  {
    path: '/products/batch',
    name: 'ProductBatchList',
    component: ProductBatchList,
    meta: {
      auth: true
    }
  },
  {
    path: '/products/delete',
    name: 'ProductDeleteList',
    component: ProductDeleteList,
    meta: {
      auth: true
    }
  },
  {
    path: '/products/export',
    name: 'ProductExport',
    component: ProductExport,
    meta: {
      auth: true
    }
  },
  {
    path: '/travel-groups/cowell-group-list',
    name: 'CowellGroupList',
    component: CowellGroupList,
    meta: {
      auth: true
    }
  },
  {
    path: '/travel-groups',
    name: 'TravelGroupList',
    component: TravelGroupList,
    meta: {
      auth: true
    }
  },
  {
    path: '/travel-groups/advance',
    name: 'TravelGroupAdvanceList',
    component: TravelGroupAdvanceList,
    meta: {
      auth: true
    }
  },
  {
    path: '/travel-groups/batch',
    name: 'TravelGroupBatchList',
    component: TravelGroupBatchList,
    meta: {
      auth: true
    }
  },
  {
    path: '/travel-groups/delete',
    name: 'TravelGroupDeleteList',
    component: TravelGroupDeleteList,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/order-process',
    name: 'Orders',
    component: Orders,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/inquiry-process',
    name: 'Inquiries',
    component: Inquiries,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/lecture-orders',
    name: 'LectureOrders',
    component: LectureOrders,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/cruise-inquiries',
    name: 'CruiseInquiries',
    component: CruiseInquiries,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/demands',
    name: 'Demands',
    component: Demands,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/complaints',
    name: 'Complaints',
    component: Complaints,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/travel-group-report-records',
    name: 'TravelGroupReportRecords',
    component: TravelGroupReportRecords,
    meta: {
      auth: true
    }
  },
  {
    path: '/order-management/publication-demands',
    name: 'PublicationDemands',
    component: PublicationDemands,
    meta: {
      auth: true
    }
  },
  {
    path: '/log/auth',
    name: 'auth-logs',
    component: AuthLogs,
    meta: {
      auth: true
    }
  },
  {
    path: '/log/group-price',
    name: 'group-price-logs',
    component: GroupPrice,
    meta: {
      auth: true
    }
  },
  {
    path: '/log/group-status',
    name: 'group-status-logs',
    component: GroupStatus,
    meta: {
      auth: true
    }
  },
  {
    path: '/log/product-price',
    name: 'product-price-logs',
    component: ProductPrice,
    meta: {
      auth: true
    }
  },
  {
    path: '/log/product-status',
    name: 'product-status-logs',
    component: ProductStatus,
    meta: {
      auth: true
    }
  },
  {
    path: '/users/user-list',
    name: 'user-list',
    component: UserList,
    meta: {
      auth: true
    }
  },
  {
    path: '/mis/attributes',
    name: 'attributes',
    component: Attributes,
    meta: {
      auth: true
    }
  },
  {
    path: '/line/auth',
    name: 'line-auth',
    component: LineAuth
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  }
]

export default routes
